import { useState, useRef, useEffect, useCallback } from 'react';
import styles from './InfoTip.module.css';

const InfoTip = ({ text, align = 'left' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const toggle = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen((v) => !v);
  }, []);

  useEffect(() => {
    if (!open) return;
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('pointerdown', close, true);
    return () => document.removeEventListener('pointerdown', close, true);
  }, [open]);

  return (
    <span className={styles.wrapper} ref={ref}>
      <button
        type="button"
        className={styles.icon}
        onClick={toggle}
        aria-label="More info"
        aria-expanded={open}
      >
        &#9432;
      </button>
      {open && (
        <span className={`${styles.bubble} ${align === 'right' ? styles.bubbleRight : ''}`} role="tooltip">
          {text}
        </span>
      )}
    </span>
  );
};

export default InfoTip;
